import React from 'react';
import { Icon, Divider, Tooltip } from 'antd';
import chatChannelsItemStyles from './ChatConversationItem.module.css';
import { apiPut } from '../brainApi';
import { isEmpty } from '../helper';

const ConversationQuickActions = ({
  conversationSid,
  handleTicketUpdate,
  email,
  lastMessage,
  ticketHistory,
  isConversationRead,
  setIsConversationRead,
}) => {
  const markAsUnread = (e) => {
    e.stopPropagation();
    apiPut(`/twilio/conversation/${conversationSid}/read-receipt`, {
      markAsUnread: true,
    }).then(setIsConversationRead);
  };

  const ticketStatus = ticketHistory
    ? ticketHistory[ticketHistory.length - 1].status
    : null;

  return (
    <div className={chatChannelsItemStyles['quick-actions']}>
      <Divider
        type="vertical"
        className={chatChannelsItemStyles['quick-actions-divider']}
      />
      {isConversationRead && !isEmpty(lastMessage) && (
        <Tooltip
          placement="bottom"
          title="Mark as unread"
          mouseEnterDelay={0.5}
        >
          <span
            className={chatChannelsItemStyles['quick-actions-icon-bkgd']}
            onClick={markAsUnread}
          >
            <Icon
              type="mail"
              className={chatChannelsItemStyles['quick-actions-icon']}
            />
          </span>
        </Tooltip>
      )}
      {ticketStatus !== 'Resolved' && (
        <Tooltip placement="bottom" title="Resolve" mouseEnterDelay={0.5}>
          <span
            className={chatChannelsItemStyles['quick-actions-icon-bkgd']}
            onClick={(e) =>
              handleTicketUpdate(e, conversationSid, email, 'Resolved')
            }
          >
            <Icon
              type="check"
              className={chatChannelsItemStyles['quick-actions-icon']}
            />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default ConversationQuickActions;
